<template>
	<div>
		<headerTop value="2"></headerTop>
		<div class="shenbaoA flex justify-between align-start" v-loading="loading" element-loading-text="加载中">
			<div class="bg-white" style="width: 100%;padding: 20px 50px;border-radius: 10px;">
				<div class="box1_header" style="margin-bottom: 20px;border:none;">
					<div class="box1_header_shu"></div>
					<div class="box1_header_text">政策资讯</div>
				</div>
				<div class="">
					<div class="box2_until">
						<div v-for="(item, index) in typelist" :key="index" class="borbot" style="margin-bottom: 10px">
							<div class="box2_until_center">
								<div class="box2_until_left">{{ item.name }}:</div>
								<div class="box2_cent">
									<div v-for="(citem, cindex) in item.union_type"
										@click.stop="tochoose(index, cindex, citem.id, citem.name, item.id,citem.pid)"
										:key="cindex" class="box2_until_right cpoint"
										:class="citem.checked ? 'sty' : ''">
										{{ citem.name }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="shenbaoleft">
					<ul>
						<li v-for="(item, index) in tablist" :key="index"
							class="search cpoint" :class="item.checked ? 'active1' : ''"
							@click="tochange(index, item.type, item.tindex)">
							{{ item.title }}
						</li>
					</ul>
				</div>
				<div v-if="rightlist.length" class="shenbaoright" style="width:calc(100% - 140px)">
					<div class="box5 box2_cc">
						<div class="box5_text1 text-cut">标题</div>
						<div class="box5_text2 text-cut">发布等级</div>
						<div class="box5_text2 text-cut">发布区域</div>
						<div class="box5_text2 text-cut">发布日期</div>
						<div class="box5_text2 text-cut">截止日期</div>
						<div class="box5_text2 text-cut">剩余天数</div>
						<div class="box5_text3 text-cut">操作</div>
					</div>
					<div style="min-height: 550px;">
						<div v-for="(item, index) in rightlist" :key="index" class="box5">
							<div class="box5_text1">
								{{ item.title }}
							</div>

							<div class="box5_text2">
								<span>{{item.fbdj ? item.fbdj : '--'}}</span>
							</div>
							<div class="box5_text2">
								{{item.fbqy ? item.fbqy : '--'}}
							</div>
							<div class="box5_text2">{{ item.fbtime ? item.fbtime : '--' }}</div>
							<div class="box5_text2">{{ item.jztime ? $time(item.jztime) : '--' }}</div>
							<div class="box5_text2">{{ timetemp > item.jztime?'已截止' : $days($time(item.jztime),nowTime) }}</div> 
							<div class="box5_text3 text-cut">
								<!-- @click="todetail('detail', item.id, 2)" -->
								<div class="box2_nei cpoint" @click="todetail(item.href)">查看详情</div>
							</div>
						</div>
					</div>
					<div class="text-center" style="padding: 10px 0">
						<el-pagination background :page-size="pagesize" :hide-on-single-page="true"
							layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="currentPage" :total="totalnum">
						</el-pagination>
					</div>
				</div>
				<div v-if="!rightlist.length" class="shenbaoright">
					<div class="nodata flex justify-center align-center flex-direction">
						<div class="" style="font-size: 18px">暂无数据</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import headerTop from "../../components/headerTop.vue";
	export default {
		components: {
			headerTop: headerTop,
		},
		data() {
			return {
				query: "",
				loading:false,
				navtype: 0,
				bg: "#ff9700",
				tablist: [{
						title: "全部",
						checked: true,
						tindex: 0,
						type: 0,
					},
					{
						title: "申报公示",
						checked: false,
						tindex: 1,
						type: 1,
					},
					{
						title: "其他",
						checked: false,
						// type: 5,
						tindex: 2,
						type: 5,
					},
				],
				rightlist: [],
				type: 0,
				tindex: 0,
				totalnum: null,
				pagesize: 20,
				currentPage: 1,
				typelist: [],
				area: '',
				city: '',
				advertiselist: [],
				nowTime:'',
				timetemp:'',
			};
		},
		created() {
			this.timetemp = Date.parse(new Date()) / 1000;
			this.nowTime = this.$time(this.timetemp);
			this.getlist();
		},
		methods: {
			// todetail(name, id, type) {
			// 	this.$router.push({
			// 		name: name,
			// 		query: {
			// 			type: type,
			// 			id: id
			// 		}
			// 	});
			// },
			todetail(url) {
				window.open(url)
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
				this.getlist();
			},
			tochange(index, type, tindex) {
				for (let i in this.tablist) {
					this.tablist[i].checked = false;
				}
				this.tablist[index].checked = true;
				this.type = type;
				this.tindex = tindex;
				this.getlist();
			},
			tonextpage(name, id) {
				this.$router.push({
					name: name,
					params: {
						id: id
					}
				});
			},
			getlist() {
				let _this = this;
				_this.loading = true;
				_this.$api.user.financial_policy_list({
					page: _this.currentPage,
					pageSize: 20,
					keyword:_this.city,
					// area: _this.area,
					// city: _this.city
				}).then(res => {
					console.log(res,999)
					if (res.code == 1) {
						
						for (let i in _this.tablist) {
							_this.tablist[i].checked = false;
						}
						_this.tablist[_this.tindex].checked = true;
						_this.totalnum = res.data.count;
						_this.rightlist = res.data.list;
						_this.loading = false;
					} 
				})
			},
			// gettypelist(id) {20241225政策宝通知该接口失效
			// 	let _this = this;
			// 	_this.$api.user.get_city_area({
			// 		id: id
			// 	}).then(res => {
			// 		if (res.code == 1) {
			// 			if (id == 20) {
			// 				var list = [];
			// 				var arr = {
			// 					name: "地区",
			// 					union_type: [],
			// 					id: 0,
			// 				};
			// 				list.push(arr);
			// 				list[0].union_type = res.data;
			// 				list[0].union_type.unshift({
			// 					name: "全部",
			// 					id: 0,
			// 					checked: true,
			// 					pid: 0
			// 				});
			// 				this.typelist = list;
			// 			} else {
			// 				var arr = {
			// 					name: "区域",
			// 					union_type: [],
			// 					id: 0,
			// 				};
			// 				this.typelist[1] = arr;
			// 				this.typelist[1].union_type = res.data;
			// 				this.typelist[1].union_type.unshift({
			// 					name: "全部",
			// 					id: 'all',
			// 					checked: true,
			// 					pid: 'all'
			// 				});
			// 			}
			// 			this.$forceUpdate();
			// 		}
			// 	})
			// },

			tochoose(index, cindex, cid, name, id, pid) {
				for (let i in this.typelist[index].union_type) {
					this.typelist[index].union_type[i].checked = false;
				}
				this.typelist[index].union_type[cindex].checked = true;
				if (pid == 0) {
					this.area = '';
					this.city = '';
					this.typelist.splice(1, 1);
				} else if (pid == 20) {
					// this.gettypelist(cid);
					// this.city = cid;
					this.city = name;
					this.area = '';
				} else {
					if (cid == 'all') {
						this.area = 0;
					} else {
						this.area = cid;
					}
				}
				this.rightlist = [];
				this.currentPage = 1;
				this.getlist();
				this.$forceUpdate();
			},
			// getadv() {20241225政策宝通知该接口失效
			// 	let _this = this;
			// 	_this.$api.user.get_advertise({
			// 		type: 4
			// 	}).then(res => {
			// 		if (res.code == 1) {
			// 			_this.advertiselist = res.data;
			// 		}
			// 	})
			// }
		},
	};
</script>
<style scoped>
	.shenbaoA {
		width: 1350px;
		margin: 120px auto 20px;
		height: auto;
		margin-bottom: 40px;
	}

	.shenbaoleft {
		width: 120px;
		height: auto;
		overflow: hidden;
		float: left;
		margin-right: 20px;
		background-color: #eee;
	}

	.shenbaoright {
		width: 1060px;
		/* width: 860px; */
		height: auto;
		overflow: hidden;
		float: left;
	}

	.shenbaoleft li {
		width: 118px;
		height: 60px;
		line-height: 60px;
		text-align: center;
	}

	.shenbaoleft ul {
		border: 1px solid #e5e5e5;
	}

	.shenbaoleft .active1 {
		background: #fff;
		color: #0070c0;
		border-left: 2px solid #0070c0;
		width: 116px;
	}

	.shenbaoright ul {
		border: 1px solid #eee;
		padding: 0 10px;
		min-height: 742px;
		/* height: 700px; */
		/* overflow-x: hidden;
    	overflow-y: auto; */
	}

	.shenbaoright li {
		border-bottom: 1px dashed #eee;
		line-height: 36px;
		position: relative;
	}

	.shenbaoright li span {
		position: absolute;
		top: 0;
		right: 0;
	}

	.nodata {
		border: 1px solid #eee;
		padding: 10px;
		min-height: 742px;
	}

	.box2_until_center {
		display: flex;
	}

	.box2_until_left {
		font-size: 14px;
		color: #959595;
		width: 65px;
		line-height: 28px;
	}

	.box2_until_right {
		height: 28px;
		font-size: 14px;
		line-height: 28px;
		padding: 0 8px;
		color: #4e4e4e;
		margin-left: 22px;
		margin-bottom: 10px;
	}

	.borbot {
		border-bottom: 1px solid #eee;
	}

	.box2_cent {
		display: flex;
		width: 93%;
		flex-wrap: wrap;
		min-height: 38px;
	}

	.sty {
		color: #ffffff;
		background: #0070c0;
	}

	.box1_header {
		display: flex;
		padding: 0 15px;
		align-items: center;
	}

	.box1_header_text {
		font-size: 20px;
		color: #111111;
		font-weight: 600;
		margin-left: 10px;
	}

	.box1_header_shu {
		width: 4px;
		height: 21px;
		background-color: #0070c0;
	}

	.cright {
		position: sticky;
		top: 20px;
	}

	.box5 {
		width: 100%;
		display: flex;
		min-height: 50px;
		border-bottom: 1px solid #f1f1f1;
	}

	.box5_text1 {
		width: 31%;
		display: flex;
		align-items: center;
		border-right: 1px solid #f1f1f1;
		border-left: 1px solid #f1f1f1;
		padding: 5px;
		justify-content: center;
	}

	.box5_text2 {
		width: 14%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.box5_text3 {
		width: 13%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.sty {
		color: #ffffff;
		background: #0070c0;
	}

	.box2_cc {
		color: #ffffff;
		background-color: #0070c0;
	}

	.box2_nei {
		/* width: 95px; */
		height: 30px;
		padding: 0 15px;
		/* background-color: #ff6c00; */
		background-color: #0160a3;
		color: #ffffff;
		border-radius: 7px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>


// WEBPACK FOOTER //
// policy.vue?d022058e